import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {Svg} from "assets";
import {ButtonMain} from "components";
import {FindLoad, FindSuccess, usePrimaryModal} from "utils";
import {httpRequestsOnSuccessActions} from "store";

export const LeaveModal = ({handleSave, handleCancel, actionType}) => {
    const dispatch = useDispatch();
    const {closePrimary} = usePrimaryModal();
    const loading = FindLoad(actionType);
    const success = FindSuccess(actionType);

    useEffect(() => {
        if (success) {
            closePrimary();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
        }
    }, [success]);

    return (
        <div className='delete-modal' style={{maxWidth: '100%'}}>
            <Svg.InfoSvg/>
            <div>
                <p className="delete-modal-title" style={{margin: '0 0 8px'}}>Leave without saving?</p>
                <p className="delete-modal-desc">You have unsaved changes. If you close now, your changes will be
                    lost.</p>
            </div>
            <div
                className="flex-end"
                style={{gap: 8, marginTop: 16, paddingTop: 8}}
            >
                <ButtonMain
                    cancel
                    text="Don't Save"
                    onClick={handleCancel}
                    buttonMainStyles={{minWidth: '100px'}}
                />
                <ButtonMain
                    actionTye={''}
                    text="Save"
                    type="button"
                    onClick={handleSave}
                    load={!!loading?.length}
                />
            </div>
        </div>
    );
};

